<!-- =========================================================================================
	File Name: Error404.vue
	Description: 404 Page
========================================================================================== -->


<template>
	<div class="h-screen flex w-full bg-img">
		<div class="vx-col flex items-center justify-center flex-col sm:w-1/2 md:w-3/5 lg:w-3/4 xl:w-3/5 mx-auto text-center">
			<img src="../../assets/images/pages/404.png" alt="graphic-404" class="mx-auto mb-4 responsive">
			<h1 class="mb-12 text-5xl">404 - Page Not Found!</h1>
			<vs-button size="large" @click="back()">Back</vs-button>
		</div>
	</div>
</template>

<script>
export default {
	methods : {
		back() {
			history.back()
		}
	}
}
</script>